<template>
    <div class="row" style="background-color: white; padding: 15px;">
        <div class="small-6 columns">
            <div style="padding-bottom: 10px; cursor: pointer;" @click="downloadNetworthReport"><font-awesome-icon style="font-size: 1.5em;" icon="fa-file-pdf" /> Download PDF</div>
            <p>
                This is your Net Worth Summary as of <b> {{ date }}</b>. Your Net Worth is the difference between what you own (Your Assets) and what you owe (Your Liabilities). To get an accurate Net Worth statement, make certain you have entered all of your Assets and Liabilities.
            </p>
            <div class="net-worth-summary-graph">
                <highcharts
                    :options="chartOptions" :update-args="updateArgs"></highcharts>
            </div>
            <div class="net-worth-summary-details">
                <ul>
                     <li class="assets">
                         <label>Asset: Accounts</label>
                         <span>{{ netWorthSummaryData['totalAccounts'] | money }}</span>
                     </li>
                     <li class="assets">
                         <label>Asset: Properties</label>
                         <span>{{ netWorthSummaryData['propertiesTotalValue'] | money }}</span>
                     </li>
                     <li class="assets">
                         <label>Asset: Insurances</label>
                         <span>{{ netWorthSummaryData['allInsuranceCashBenefit'] | money }}</span>
                     </li>
                     <li class="assets">
                         <label>Asset: Other Assets</label>
                         <span>{{ netWorthSummaryData['totalOtherAssets'] | money }}</span>
                     </li>
                     <li class="assets">
                         <label>Asset: Total Assets</label>
                         <span>{{ netWorthSummaryData['totalPositive'] | money }}</span>
                     </li>
                     <li class="assets" style="border-bottom: solid gray 1px;">
                         <label>Asset: Total Assets</label>
                         <span>{{ netWorthSummaryData['totalPositive'] | money }}</span>
                     </li>
                     <li  class="liabilities" style="border-bottom: solid gray 1px;">
                         <label>Total Liabilities</label>
                         <span>{{ netWorthSummaryData['totalOwed'] | money }}</span>
                    </li>
                    <li class="net-worth" style="border-bottom: solid gray 1px;">
                        <label>Total Net Worth</label>
                        <span>{{ netWorthSummaryData['totalNetworth'] | money }}</span>
                    </li>
                    <li class="life-insurances" style="border-bottom: solid gray 1px;">
                        <label>Total Life Insurance</label>
                        <span>{{ netWorthSummaryData['totalInsuranceDb'] | money }}</span>
                    </li>
                    <li class="estate" style="border-bottom: solid gray 1px;">
                        <label>Total Estate</label>
                        <span>{{ netWorthSummaryData['totalEstate'] | money }}</span>
                    </li>
                </ul>
            </div>

        </div>
        <div class="small-6 columns"  style="padding: 20px;">
            <div class="money-map-net-worth-summary-section">
                <h5 class="section-title"><b>Assets</b></h5>
                <div class="money-map-net-worth-summary-section-content">
                    Accounts
                    <ul>
                        <li class="net-worth-list">
                            <span class="net-worth-list-item">Investable Asset</span>
                            <span>{{ netWorthSummaryData.investableAssetsTotal | money }}</span>
                        </li>
                        <li class="net-worth-list">
                            <span class="net-worth-list-item">Emergency Fund</span>
                            <span>{{ netWorthSummaryData.iavAccountsStatisticsEmergencyFundsTotal | money }}</span>
                        </li>
                    </ul>
                </div>
                <div
                    v-if="properties.length > 0"
                    class="money-map-net-worth-summary-section-content">
                    Properties
                    <ul>
                        <li
                            class="net-worth-list"
                            v-for="property in properties"
                            :key="property.id">
                            <span class="net-worth-list-item">{{ property.name }}</span>
                            <span>{{ property.value | money }}</span>
                        </li>
                    </ul>
                </div>
                <div
                    v-if="assets.length > 0"
                    class="money-map-net-worth-summary-section-content">
                    Other Assets
                    <ul>
                        <li
                            class="net-worth-list"
                            v-for="asset in assets"
                            :key="asset.id">
                            <span class="net-worth-list-item">{{ asset.name }}</span>
                            <span>{{ asset.value | money }}</span>
                        </li>
                    </ul>
                </div>
                <div class="money-map-net-worth-summary-section-content">
                    Insurances
                    <ul>
                        <li class="net-worth-list">
                            <span class="net-worth-list-item">Cash Value</span><span>{{  netWorthSummaryData.allInsuranceCashBenefit | money }}</span>
                        </li>

                    </ul>
                </div>
                <div style="text-align: right; padding-right: 0px;"><b>Total: </b> {{ netWorthSummaryData.totalPositive | money }}</div>
            </div>
            <div class="money-map-net-worth-summary-section">
                <h5 class="section-title"><b>Liabilities</b></h5>
                <div
                    v-if="liabilities.length > 0"
                    class="money-map-net-worth-summary-section-content">
                    <ul  style="border-top: none;">
                        <li
                            v-for="liability in liabilities"
                            class="net-worth-list"
                            :key="liability.id">
                            <span class="net-worth-list-item">{{ liability.name }}</span>
                            <span>{{ liability.amount_owed | money }}</span>
                        </li>
                    </ul>
                </div>
                <div
                    v-if="properties.length > 0"
                    class="money-map-net-worth-summary-section-content">
                    Mortgages
                    <ul>
                        <li
                            v-for="property in properties"
                            class="net-worth-list"
                            :key="property.id">
                            <span class="net-worth-list-item">{{ property.name }}</span>
                            <span>{{ property.mortgage | money }}</span>
                        </li>
                    </ul>
                </div>
                <div style="text-align: right; padding-right: 0px;"><b>Total: </b>{{ netWorthSummaryData['totalOwed'] | money }}</div>
            </div>
            <div
                v-if="lifeInsurances.length > 0"
                class="money-map-net-worth-summary-section">
                <h5 class="section-title"><b>Life Insurances</b></h5>
                <div class="money-map-net-worth-summary-section-content">
                    <ul style="border-top: none;">
                        <li
                            v-for="lifeInsurance in lifeInsurances"
                            class="net-worth-list"
                            :key="lifeInsurance.id">
                            <span class="net-worth-list-item">{{ lifeInsurance.individual.name }}</span>
                            <span>{{ lifeInsurance.death_benefit | money }}</span>
                        </li>
                    </ul>
                </div>
                <div style="text-align: right; padding-right: 0px;"><b>Total: </b>{{ netWorthSummaryData['totalInsuranceDb'] | money }}</div>
            </div>
            <div class="money-map-net-worth-summary-section">
                <h5 class="section-title"><b>Estate</b></h5>
                <div style="text-align: right; padding-right: 0px"><b>Total: </b>{{ netWorthSummaryData['totalEstate'] | money }}</div>
            </div>
            <div class="money-map-net-worth-summary-section">
                <h5 class="section-title"><b>Net Worth</b></h5>
                <div style="text-align: right; padding-right: 0px"><b>Total: </b>{{ netWorthSummaryData['totalNetworth'] | money }}</div>
            </div>
        </div>
    </div>
</template>

<style>
.net-worth-summary-details label {
    display: inline
}

.net-worth-summary-details span {
    float: right;
    font-weight: bold;
}

.net-worth-summary-details li:before {
    content: "▪ ";
    font-size: 22px;
}

.net-worth-summary-details li.assets:before {
    color: #05ae97;
}

.net-worth-summary-details li.liabilities:before {
    color: #cd4e38;
}

.net-worth-summary-details li.net-worth:before {
    color: #de6a00;
}

.net-worth-summary-details li.life-insurances:before {
    color: #000066;
}

.net-worth-summary-details li.estate:before {
    color: #3293c6;
}

.net-worth-list {
    display: flex;
    justify-content: space-between;
}

.net-worth-list-item {
    word-wrap: break-word;
    margin-right: 8px;
}
.section-title {
    border-bottom: solid black 3px;
    font-size: 1.2em;
}
.money-map-report, .money-map-report-cell, .money-map-net-worth-summary, .money-map-net-worth-summary-section {
    text-align: left;
    height: max-content;
}

.money-map-report div ul, .money-map-report-cell div ul, .money-map-net-worth-summary div ul {
    border-top: solid black 1px;
    border-bottom: solid black 1px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    text-align: left;
}

.money-map-report, .money-map-report-cell, .money-map-net-worth-summary, .money-map-net-worth-summary-section-content {
    height: max-content;
    text-align: left;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 10px;
    margin-bottom: 10px;
}

.money-map-net-worth-summary ul li {
    padding-left: 10px;
    list-style: unset;
}


.money-map-report i {
    color: white !important;;
}

.money-map-report-cell div{
    text-align: center;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
    word-wrap: break-word;
    height: 100%;
}

.money-map-report-header{
    text-align: center;
}

.money-map-report-header th{
    padding-bottom: 0px;
}

.money-map-report tbody h4 {
    color: white !important;
    background-color: darkblue !important;
    padding: 5px;
}

.money-map-report-cell p {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
}

.money-map-report tr {
    height: 100%;
}

.money-map-report td {
    height: 100%;
}


.money-map-report li {
    list-style: initial;
}

.money-map-report li.account {
    list-style: none !important;
}


.money-map-report table {
    border: none;
}

.small-6 {
    width: 50%;
}

.column.small-centered,
.columns.small-centered {
    margin-left: auto;
    margin-right: auto;
    float: none;
}

.column.small-uncentered,
.columns.small-uncentered {
    float: left;
    margin-left: 0;
    margin-right: 0;
}

.column.small-centered:last-child,
.columns.small-centered:last-child {
    float: none;
}

.column.small-uncentered:last-child,
.columns.small-uncentered:last-child {
    float: left;
}

.column.small-uncentered.opposite,
.columns.small-uncentered.opposite {
    float: right;
}

li {
    list-style: none;
}
</style>

<script>
import {Chart} from 'highcharts-vue'
import axios from "axios";

export default {
    components: {
        highcharts: Chart
    },
    props: {
        netWorthSummaryData: {
            type: Object,
            required: false
        },
        properties: {
            type: Array,
            default: () => [],
            required: false
        },
        lifeInsurances: {
            type: Array,
            default: () => [],
            required: false
        },
        liabilities: {
            type: Array,
            default: () => [],
            required: false
        },
        assets: {
            type: Array,
            default: () => [],
            required: false
        },
        date: {
            type: String,
            required: true,
        }
    },
    computed: {
        chartOptions() {
            return {
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                    }]
                },
                chart: {
                    defaultSeriesType: 'column',
                    width: 500,
                    height: 300,
                    backgroundColor: 'transparent',
                    plotBackgroundColor: 'transparent',
                    animation: false
                },
                xAxis: {
                    categories: ['Assets', 'Life Insurance', 'Liabilities', 'Net Worth', 'Total Estate'],
                    labels: false
                },
                series: [
                    {
                        type: 'column',
                        name: 'Assets',
                        color: '#05ae97',
                        data: [this.netWorthSummaryData['totalPositive']]
                    },
                    {
                        type: 'column',
                        color: '#cd4e38',
                        name: 'Liabilities',
                        data: [this.netWorthSummaryData['totalOwed']]
                    },
                    {
                        type: 'column',
                        color: '#de6a00',
                        name: 'Net Worth',
                        data: [this.netWorthSummaryData['totalNetworth']]
                    },
                    {
                        type: 'column',
                        color: '#000066',
                        name: 'Life Insurance',
                        data: [this.netWorthSummaryData['totalInsuranceDb']]
                    },
                    {
                        type: 'column',
                        color: '#3293c6',
                        name: 'Total Estate',
                        data: [this.netWorthSummaryData['totalEstate']]
                    },
                ],
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true,
                        },
                        animation: false,
                        enableMouseTracking: false,
                        shadow: false
                    }
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                }
            }
        }
    },

    inject: ['householdId'],

    data() {
        return {
            updateArgs: [true, true, {duration: 1000}],
        }
    },
    methods: {
        downloadNetworthReport() {
            axios.get('/api/households/' + this.householdId + '/client-accounts-reports/net-worth-summary')
                .then(() => {
                    this.reportLoading = true;
                });
        }
    }
}
</script>
